<template lang="pug">
v-app#inspire
  app-side-nav(v-if="isAuthenticated() && !isFullScreen" ref="nav")
  algolia-side-panel-search(v-if="isAuthenticated() && !isFullScreen")
  app-header(v-if="isAuthenticated()" @parentFn="CheckUpdate")
  v-content(fill-height id="main-container")
    loader
    refresh-token
    snack-bar
    alert
    v-slide-y-transition
      router-view(@updateNav="NavTreeUpdate")
</template>

<script>
import * as types from '@/store/mutationTypes';
import { mapState, mapGetters } from 'vuex';
import AppHeader from '@/components/core/AppHeader';
import AppFooter from '@/components/core/AppFooter';
import AppSideNav from '@/components/core/AppSideNav';
import Loader from '@/components/core/Loader';
import RefreshToken from '@/components/core/RefreshToken';
import Alert from '@/components/core/Alert';
import SnackBar from '@/components/core/SnackBar';
import AlgoliaSidePanelSearch from '@/components/content/AlgoliaSidePanelSearch';
import pkg from '../package.json';

export default {
    name: 'App',

    components: {
        AppHeader,
        AppFooter,
        AppSideNav,
        Alert,
        SnackBar,
        AlgoliaSidePanelSearch,
        Loader,
        RefreshToken
    },

    computed: {
        ...mapState({
            cursor: state => state.appearance.cursor,
            isFullScreen: state => state.appearance.isFullScreen
        }),

        ...mapGetters({
            contextItems: 'clientContext/items',
            contextValues: 'clientContext/values',
            getContextItem: 'clientContext/getContextItem',
            isAuthenticated: 'session/isAuthenticated'
        }),
    },


    async beforeCreate() {
        // Start up procedure
        try {
            await this.$store.dispatch(
                'appInitialise',
                pkg.version,
                { root: true }
            );
        } catch (err) {
            if (err.message === 'Network Error') {
                this.$router.push('servernotavailable');
            } else {
                this.$router.push('somethingwentwrong');
            }
            console.error(err);
        }

        if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
            this.$store.commit(types.APPEARANCE_SET_ISMOBILE, true);
        }
    },

    watch: {
        contextValues(value) {
            const CSPColours = this.getContextItem('CSPColours');
            if (CSPColours) {
                const contextTheme = CSPColours.value;
                try {
                    const ctp = JSON.parse(contextTheme);
                    if (ctp && ctp.primary) this.$vuetify.theme = ctp;
                } catch (e) {
                    console.log('Unable to process CSPColours : ', e);
                }
            }
        },
        cursor(value) {
            switch (value) {
                case 'progress':
                    document.body.classList.add('busy-cursor');
                    break;
                default:
                    document.body.classList.remove('busy-cursor');
                    break;
            }
        },
    },

    methods: {
        CheckUpdate() {
            this.$refs.nav.getUpdate(true);
        },

        NavTreeUpdate(details) {
            this.$refs.nav.treeUpdate(details);
        }
    },
};
</script>

<style>
@import url(//fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic);
  * {
    margin: 0;
    padding: 0;
  }

  html,
  body { height: 100%; }

  /*
  body {
    cursor: url('./resources/assets/cursor.png'), auto;
  }
  */

  body.busy-cursor {
    cursor: progress;
  }

  .vertical-center {
    display: flex;
    align-items: center;
  }

  .bottom-container {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
  }

  a {
    text-decoration: none;
  }

  .center-it {
    background-position: center;
    justify-content: center;
    text-align: center;
    justify-content: center;
    align-items: center;
  }

  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  #main-container{
    background-color: #FFF
  }
</style>



// WEBPACK FOOTER //
// src/App.vue